export function txLoading(lang: string) {
  return lang === 'en-US' ? 'Loading' : 'Obteniendo datos';
}
export function txLoadingPage(lang: string) {
  return lang === 'en-US' ? 'Loading page' : 'Cargando la página';
}
